<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-btn-toggle v-model="toggle_timestamp" @change="toggleChanged">
          <v-btn @click="setDate('3h')">
            3h
          </v-btn>
          <v-btn @click="setDate('24h')">
            24h
          </v-btn>

          <v-btn @click="setDate('3d')">
            3d
          </v-btn>
          <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="date"
            persistent
            width="640"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                <v-icon>mdi-calendar</v-icon>
              </v-btn>
            </template>
            <StatusDatePicker
              :modal="modal"
              :start="startTime"
              :end="endTime"/>
          </v-dialog>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-expansion-panels v-model="panel">
        <v-expansion-panel value=true>
          <v-expansion-panel-header>
            <div class="title">Power</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container fluid>
              <v-card class="pa-2">
                <v-row>
                  <v-col cols=12>
                    <span>Charger type: {{chargerType}}</span><br>
                    <span>Connection: {{chargerState}}</span><br>
                    <span>Status: {{chargingStatus}}</span><br>
                    <span>Charge level: {{batteryLevel}}%</span><br>
                    <BatteryChart :id="device.id" :start="startTime" :end="endTime"></BatteryChart>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="title">Temperatures</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container fluid>
              <v-card class="pa-2">
                <v-row>
                  <v-col cols=12>
                    <TemperatureChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="title">Network</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container fluid>
              <v-card class="pa-2">
                <v-row>
                  <v-col cols=12>
                    <v-container fluid class="pa-2">
                      Outgoing video bitrate
                      <BandwithChart :id="device.id" :start="startTime" :end="endTime"/>
                      Network Status
                      <NetworkStatusTable :id="device.id" :start="startTime" :end="endTime"/>
                      WIFI Status
                      <WifiStatusTable :id="device.id" :start="startTime" :end="endTime"/>
                      Linkspeed
                      <LinkSpeedChart :id="device.id" :start="startTime" :end="endTime"/>
                      RSSI
                      <RssiChart :id="device.id" :start="startTime" :end="endTime"/>
                      Signal quality
                      <SignalQualityChart :id="device.id" :start="startTime" :end="endTime"/>
                    </v-container>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="title">Load</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container fluid>
              <v-card class="pa-2">
                <v-row>
                  <v-col cols=12>
                    <CpuFrequencyChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                  <v-col cols=12>
                    <CpuUsageChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                  <v-col cols=12>
                    <RamChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                  <v-col cols=12>
                    <RamVmChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                  <v-col cols=12>
                    <RamMaxVmChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                  <v-col cols=12>
                    <RamNativeHeapChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="title">Storage</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container fluid>
              <v-card class="pa-2">
                <v-row>
                  <v-col cols=12>
                    <DiskOsChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                  <v-col cols=12>
                    <DiskDataChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                  <v-col cols=12>
                    <DiskExtChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                  <v-col cols=12>
                    <DiskSdChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                  <v-col cols=12>
                    <DiskUsbChart :id="device.id" :start="startTime" :end="endTime"/>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
import gql from 'graphql-tag';
import BandwithChart from '@/components/Device/BandwithChart.vue';
import LinkSpeedChart from '@/components/Device/LinkSpeedChart.vue';
import RssiChart from '@/components/Device/RssiChart.vue';
import SignalQualityChart from '@/components/Device/SignalQualityChart.vue';
import BatteryChart from '@/components/Device/BatteryChart.vue';
import CpuFrequencyChart from '@/components/Device/CpuFrequencyChart.vue';
import CpuUsageChart from '@/components/Device/CpuUsageChart.vue';
import RamChart from '@/components/Device/RamChart.vue';
import RamVmChart from '@/components/Device/RamVmChart.vue';
import RamMaxVmChart from '@/components/Device/RamMaxVmChart.vue';
import RamNativeHeapChart from '@/components/Device/RamNativeHeapChart.vue';
import DiskOsChart from '@/components/Device/DiskOsChart.vue';
import DiskDataChart from '@/components/Device/DiskDataChart.vue';
import DiskExtChart from '@/components/Device/DiskExtChart.vue';
import DiskSdChart from '@/components/Device/DiskSdChart.vue';
import DiskUsbChart from '@/components/Device/DiskUsbChart.vue';
import TemperatureChart from '@/components/Device/TemperatureChart.vue';
import NetworkStatusTable from '@/components/Device/NetworkStatusTable.vue';
import WifiStatusTable from '@/components/Device/WifiStatusTable.vue';
import StatusDatePicker from '@/components/Device/StatusDatePicker.vue';

import EventBus from '@/utils/EventBus';


const LATEST_BATTERY_CHARGING_STATUS = gql`
  subscription latest_battery_charging_status($device: String!) {
    battery_charging_status(
      where: {
        device_id: {
          _eq: $device
        }
      }
      order_by: {
        timestamp: desc
      }
      limit: 1
    ) {
      is_charger_connected
      charging_status
      charger_type
    }
  }
`;
const LATEST_BATTERY_LEVEL = gql`
  subscription latest_battery_level($device: String!) {
    battery(
      where: {
        device_id: {
          _eq: $device
        }
      }
      order_by: {
        timestamp: desc
      }
      limit: 1
    ) {
      level
    }
  }
`;

export default {
  name: 'DeviceTabStatus',
  data() {
    return {
      chargerType: 'N/A',
      chargingStatus: 'N/A',
      isChargerConnected: false,
      batteryLevel: 'N/A',
      toggle_timestamp: 1,
      modal: false,
      date: null,
      startTime: new Date(new Date().getTime() - (24 * 60 * 60 * 1000)).toISOString(),
      endTime: new Date().toISOString(),
      dateChanged: false,
      panel: 0,
    };
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  components: {
    BatteryChart,
    CpuFrequencyChart,
    CpuUsageChart,
    RamChart,
    RamVmChart,
    RamMaxVmChart,
    RamNativeHeapChart,
    DiskOsChart,
    DiskDataChart,
    DiskExtChart,
    DiskSdChart,
    DiskUsbChart,
    TemperatureChart,
    NetworkStatusTable,
    WifiStatusTable,
    StatusDatePicker,
    BandwithChart,
    LinkSpeedChart,
    RssiChart,
    SignalQualityChart,
  },
  mounted() {
    EventBus.$on('date-picker-closed', this.datePickerClosed);
  },
  beforeDestroy() {
    EventBus.$off('date-picker-closed', this.datePickerClosed);
  },
  computed: {
    chargerState() {
      return this.isChargerConnected ? 'Connected' : 'Not connected';
    },
  },
  methods: {
    toggleChanged(val) {
      if (val > 3) {
        if (this.dateChanged) {
          setTimeout(() => {
            this.toggle_timestamp = 3;
          }, 200);
        } else {
          setTimeout(() => {
            this.toggle_timestamp = this.previousToggleValue;
          }, 200);
        }
      } else if (val >= 0 && val < 3) {
        this.previousToggleValue = val;
      }
    },
    datePickerClosed(data) {
      this.modal = false;
      if (data.changed) {
        this.dateChanged = true;
        this.startTime = data.startTime;
        this.endTime = data.endTime;
        EventBus.$emit('monitoring-time-changed', { startTime: this.startTime, endTime: this.endTime });
      } else {
        this.dateChanged = false;
      }
    },
    setDate(val) {
      let dateOffset;
      switch (val) {
        case '3h':
          dateOffset = 3 * 60 * 60 * 1000;
          break;
        case '24h':
          dateOffset = 24 * 60 * 60 * 1000;
          break;
        case '3d':
          dateOffset = 72 * 60 * 60 * 1000;
          break;
        default:
          console.log('custom date');
          break;
      }
      this.startTime = new Date(new Date().getTime() - dateOffset).toISOString();
      this.endTime = new Date().toISOString();
      EventBus.$emit('monitoring-time-changed', { startTime: this.startTime, endTime: this.endTime });
    },
  },
  apollo: {
    // Subscriptions
    $subscribe: {
      battery_charging_status: {
        query: LATEST_BATTERY_CHARGING_STATUS,
        variables() {
          return {
            device: this.device.id,
          };
        },
        // Result hook
        result(data) {
          // Let's update the local data
          if (data.data.battery_charging_status && data.data.battery_charging_status.length > 0) {
            this.chargerType = data.data.battery_charging_status[0].charger_type;
            this.isChargerConnected = data.data.battery_charging_status[0].is_charger_connected;
            this.chargingStatus = data.data.battery_charging_status[0].charging_status;
          } else {
            console.log('no battery charging status data');
          }
        },
      },
      latest_battery_level: {
        query: LATEST_BATTERY_LEVEL,
        variables() {
          return {
            device: this.device.id,
          };
        },
        // Result hook
        result(data) {
          // Let's update the local data
          if (data.data.battery && data.data.battery.length > 0) {
            this.batteryLevel = data.data.battery[0].level;
          } else {
            console.log('no battery data');
          }
        },
      },
    },
  },
};
</script>
